<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.mdAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.smAndDown}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/prize_basket">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-3" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Корзина") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <h1 class="section-title-main my-3 mr-4 font-weight-regular" :class="{'px-3': $vuetify.breakpoint.smAndDown}" style="cursor: default;">{{ $t("Ваш заказ успешно оформлен!") }}</h1>
                </div>
                <div class="success__description">Управлять заказом и отслеживать его статус вы можете в разделе <router-link to="/prize_order"> Мои заказы </router-link></div>
                <hr/>
                <div class="success__description">Пройти новые курсы можно <br> в разделе <router-link to="/study"> Обучение </router-link></div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
export default {
  components: {
    HeaderMenu, UserMenu, FooterBlock,
  },
};
</script>

<style scoped lang="sass">

hr
    max-width: 878px
    width: 100%
    margin: 32px 0
    border: 1px solid #DEDEDE

.success__description
    max-width: 616px
    width: 100%
    font-size: 32px
    font-weight: 300
    line-height: 44px
    font-family: 'Futura FuturisC Light'

    @media screen and (max-width: 600px)
        font-size: 24px
</style>
